import { createReducer } from '@reduxjs/toolkit';
import { lockAction, unlockAction } from 'store/actions/lockActions';

export interface IGlobalLockState {
  locked: boolean;
}

const initialState: IGlobalLockState = {
  locked: false,
};

const lockReducer = createReducer<IGlobalLockState>(initialState, (builder) => {
  builder
    .addCase(lockAction, (state) => {
      state.locked = true;
    })
    .addCase(unlockAction, (state) => {
      state.locked = false;
    });
});

export default lockReducer;
